<template>
<v-dialog v-model="showModal" width="400" @click:outside=closeDialog>
      <v-card max-width="400">
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="text-h5 text-medium-emphasis ps-2 title-text" >edit bank account</div>
          <v-btn icon="mdi-close" variant="text" @click=closeDialog></v-btn>
        </v-card-title>
        <v-divider class="mb-4"></v-divider>
        <v-card-text>
          <v-sheet class="mx-auto" width="300">
            <v-form @submit.prevent ref="form">
              <v-text-field label="id" variant="underlined" class="form_field" v-model="this.bankAccount.id" disabled></v-text-field>
              <v-text-field :rules="[required]" label="bank name" variant="underlined" class="form_field" v-model="this.bankAccount.bank_name"></v-text-field>
              <v-text-field :rules="[required]" label="account name" variant="underlined" class="form_field" v-model="this.bankAccount.account_name"></v-text-field>
              <v-text-field :rules="[required]" label="account nickname" variant="underlined" class="form_field" v-model="this.bankAccount.account_nickname"></v-text-field>
              <v-text-field :rules="[required]" label="bsb" variant="underlined" class="form_field" v-model="this.bankAccount.bsb"></v-text-field>
              <v-text-field :rules="[required]" label="account number" variant="underlined" class="form_field" v-model="this.bankAccount.account_number"></v-text-field>
              <v-text-field :rules="[required]" label="starting txn import date" variant="underlined" class="form_field" v-model="this.importDateCopy" type="date"></v-text-field>
              <v-switch label="hide this account" v-model="this.bankAccount.is_hidden" :true-value="1" :false-value="0" color="primary" density="compact" class="form_field"></v-switch>
            </v-form>
          </v-sheet>
        </v-card-text>
        <template v-slot:actions>
          <v-row align="center" justify="end" class="actionsRow">
            <v-btn v-on:click="submitForm" class="mt-2 submit_button" type="submit" block>update</v-btn>
            <v-btn v-on:click="submitDeleteRecord" class="mt-2 submit_button" type="submit" block>delete</v-btn>
          </v-row>
        </template>
      </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations} from 'vuex';

export default {
  props: {
    show: Boolean,
    bankAccount: Object,
    importStartingDate: String
  },
  data() {
    return {
      importDateCopy: String
      
    }
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    showModal: {
      get () {
        return this.show
      },
    },
  },
  methods: {
      ...mapMutations(["showSnackbar"]),  
    async submitForm(e) {
      e.preventDefault();
      const { valid } = await this.$refs.form.validate();
      if (!valid) return;
      try {
        
        await axios.request({
          url: "/bank/accounts/" + this.bankAccount.id,
          method: "PUT",
          headers: {
              Authorization: `Bearer ${this.token}`
          },
          data: {
            bank_name: this.bankAccount.bank_name,
            account_name: this.bankAccount.account_name,
            account_nickname: this.bankAccount.account_nickname,
            bsb: this.bankAccount.bsb,
            account_number: this.bankAccount.account_number,
            starting_txn_import_date: this.importDateCopy,
            is_hidden: this.bankAccount.is_hidden,
          }
        });
          this.$parent.getBankAccountsSummaryData(); // update list on local
          this.$emit("close"); // close modal via parent
      } catch (error) {
        this.showSnackbar({ message: 'Failed to update bank account' });
      }
    },
    async submitDeleteRecord(e) {      
      try {
        e.preventDefault();
        await axios.delete('/bank/accounts/' + this.currentRow.id,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
          }
        });
          this.$parent.getBankAccountsSummaryData(); // update list on local
          this.$emit("close"); // close modal via parent

      } catch (error) {
        this.showSnackbar({ message: 'Failed to delete bank account' });
      }
    },
    required (v) {
        return (v !== null && v !== undefined && v !== '') || 'required'
    },
    closeDialog(){
      this.$parent.getBankAccountsSummaryData();
      this.$emit('close');
    } 

  },
  watch: {
    importStartingDate(newVal) {
      this.importDateCopy = newVal;
    }
  }
  
}
</script>

<style scoped>

.title-text, .body-text, .form_field, .submit_button {
  font-family: "Space Grotesk", "Courier New", Courier, monospace, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.actionsRow{
  margin-bottom: 5px;
}

</style>